import { ChevronUpIcon } from '@chakra-ui/icons'
import { Flex, Text } from '@chakra-ui/react'
import { MotionFlex, expandedItemVariants } from './animations'
import type { ChartDataItem } from './types'

interface CollapseButtonProps {
  othersData: ChartDataItem
  onCollapse: () => void
}

export const CollapseButton = ({ othersData, onCollapse }: CollapseButtonProps) => (
  <MotionFlex
    key="collapse-button"
    align="center"
    justify="space-between"
    gap={4}
    h='32px'
    variants={expandedItemVariants}
    custom={othersData.companies?.length || 0} // Delay based on number of expanded items
    initial="hidden"
    animate="visible"
    exit="exit"
    position={'relative'}
    cursor="pointer"
    onClick={onCollapse}
    _hover={{ bg: 'gray.50' }}
    borderRadius="md"
    px={2}
    mx={-2}
  >
    <Flex align="center" w="56px" justify="center">
      <ChevronUpIcon boxSize={6} color="primary.500" />
    </Flex>
    <Flex align="center" flex={1} gap={3}
      flexGrow={1} justifyContent="space-between">
      <Text
        fontSize="xs"
        color="gray.500"
        fontWeight="medium"
      >
        Skrýt ostatní
      </Text>
    </Flex>
  </MotionFlex>
)
